import { FC } from 'react'

import LinkWrap from 'containers/link-wrap/link-wrap'
import usePCWindow from 'hooks/usePCWindow'

import { ScreenSize } from 'constants/media-constanst'
import { IFilterCard } from 'constants/types/search.types'

import styles from './two-column-cards.module.scss'

interface ITwoColumnsCards {
  cards: IFilterCard[]
}

type IDividedCards = {
  [key in 'firstHalf' | 'secondHalf']: IFilterCard[]
}

const TwoColumnsCards: FC<ITwoColumnsCards> = ({ cards }: ITwoColumnsCards) => {
  const isBigPC = usePCWindow(ScreenSize.big)
  const dividedCards = cards.reduce<IDividedCards>(
    (acc, card, index) => {
      const side = index % 2 ? 'secondHalf' : 'firstHalf'
      acc[side].push(card)

      return acc
    },
    { firstHalf: [], secondHalf: [] }
  )

  return isBigPC ? (
    <div className={styles.divided}>
      {Object.keys(dividedCards).map((half) => (
        <div className={styles.column} key={half}>
          {dividedCards[half as 'firstHalf' | 'secondHalf'].map((card) => (
            <LinkWrap
              className={styles.cardItem}
              href={card.url}
              prefetch={false}
              key={card.key || card.url}
            >
              {card.item}
            </LinkWrap>
          ))}
        </div>
      ))}
    </div>
  ) : (
    <>
      {cards.map((card) => (
        <LinkWrap
          className={styles.cardItem}
          href={card.url}
          prefetch={false}
          key={card.key || card.url}
        >
          {card.item}
        </LinkWrap>
      ))}
    </>
  )
}

export default TwoColumnsCards
